import axios from '../axios'

const url = (path) => {
    const baseURL = sessionStorage.getItem('baseURL') || 'https://demo.schooney.tech:18074'
    return `${baseURL}${path}`
}

const urlWithRapid = (path) => {
    const baseURL = process.env.VUE_APP_BACKEND_RAPID || 'https://demo.schooney.tech:18074'
    return `${baseURL}${path}`
}

// zkt service
const get = (path, config = {}) => {
    return axios.get(url(path), config)
}

const post = (path, body, config = {}) => {
    return axios.post(url(path), body, config)
}

const put = (path, body, config = {}) => {
    return axios.put(url(path), body, config)
}

const del = (path, config = {}) => {
    return axios.delete(url(path), config)
}

// rapid service
const getWithRapid = (path, config = {}) => {
    return axios.get(urlWithRapid(path), config)
}

// const postWithRapid = (path, body, config = {}) => {
//     return axios.post(urlWithRapid(path), body, config)
// }

// const putWithRapid = (path, body, config = {}) => {
//     return axios.put(urlWithRapid(path), body, config)
// }

// const delWithRapid = (path, config = {}) => {
//     return axios.delete(urlWithRapid(path), config)
// }

export default {
    get,
    post,
    put,
    del,
    getWithRapid
}
